exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#headerCarousel .carousel-caption {\n    width: 65%;\n    background: rgba(255, 255, 255, 0.3);\n    /* padding: 0 70px; */\n    background-color: blue;\n}\n\n#headerCarousel .carousel-caption h1 {\n    font-size: 30px;\n}\n\n#headerCarousel .carousel-caption .lead,\n#headerCarousel .carousel-caption .btn {\n    font-size: 18px;\n}\n\n@media all and (max-width: 700px) {\n    #headerCarousel .carousel-inner {\n        width: 100%;\n    }\n    #headerCarousel .carousel img {\n         margin-top: 0px; \n    }\n}\n\n@media all and (min-width: 700px) {\n    #headerCarousel .carousel-inner {\n        height: 25rem;\n        width: 100%;\n        /* background-color: blue; */\n    }\n    #headerCarousel .carousel img {\n        margin-top: 0px;\n    }\n} ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/header-bar/header-bar.component.css
// module id = 410
// module chunks = 0